var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('configurazioni-component',{attrs:{"pathResources":_vm.pathResources,"menuRoot":_vm.menuRoot}})}
var staticRenderFns = []

export { render, staticRenderFns }